module.exports = __webpack_public_path__ + "static/media/serv-6.44c84446.jpg";